import React, { useContext } from 'react';
import { useDeviationViewContext } from '../../../Context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType, isLegacyStatus } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import DesktopActionBar from '../../variants/DesktopActionBar';
import MobileActionBar from '../../variants/MobileActionBar';
import ExpandActionBar from '../../variants/ExpandActionBar';
import SimpleActionBar from '../../variants/SimpleActionBar';
import CommissionActionBar from '../../variants/CommissionActionBar';
import TierActionBar from '../../variants/TierActionBar';
const ActionBarContent = ({ deviation , isOwner  })=>{
    const { isFullscreen  } = useDeviationViewContext();
    const isMobile = useContext(MobileContext);
    const deviationType = getDeviationType(deviation);
    if (isFullscreen) {
        return /*#__PURE__*/ React.createElement(ExpandActionBar, {
            deviation: deviation,
            isOwner: isOwner
        });
    }
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(MobileActionBar, {
            deviation: deviation,
            isOwner: isOwner
        });
    }
    if (deviationType === DeviationTypes.STATUS && !isLegacyStatus(deviation)) {
        return /*#__PURE__*/ React.createElement(DesktopActionBar, {
            deviation: deviation,
            isOwner: isOwner
        });
    }
    switch(deviationType){
        case DeviationTypes.STATUS:
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(SimpleActionBar, {
                deviation: deviation,
                isOwner: isOwner
            });
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(CommissionActionBar, {
                deviation: deviation,
                isOwner: isOwner
            });
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierActionBar, {
                deviation: deviation,
                isOwner: isOwner
            });
        default:
            return /*#__PURE__*/ React.createElement(DesktopActionBar, {
                deviation: deviation,
                isOwner: isOwner
            });
    }
};
ActionBarContent.displayName = 'ActionBarContent';
export default ActionBarContent;
